var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0ZM2.06565 9.9074C2.35719 10.2805 3.16782 10.758 4.40826 11.1475C4.89668 11.3009 5.4316 11.4357 6.00555 11.5502C6.00186 11.3679 6 11.1844 6 11C6 7.67236 6.60556 4.6673 7.65455 2.64231C4.66412 3.84042 2.46628 6.59699 2.06565 9.9074ZM6.12914 13.6108C4.52334 13.3317 3.14644 12.9093 2.10296 12.3658C2.58837 15.5542 4.74677 18.1927 7.65455 19.3577C6.88867 17.8792 6.35916 15.8783 6.12914 13.6108ZM8.17891 13.8773C9.07601 13.9581 10.0209 14 11 14C11.9633 14 12.9124 13.9454 13.8253 13.8441C13.3742 17.4417 12.127 20 11 20C9.87647 20 8.63347 17.4574 8.17891 13.8773ZM13.9863 11.8045C13.0367 11.9275 12.028 12 11 12C9.95577 12 8.95341 11.9483 8.01531 11.8502C8.00522 11.5706 8 11.287 8 11C8 5.98399 9.5936 2 11 2C12.4064 2 14 5.98399 14 11C14 11.2713 13.9953 11.5397 13.9863 11.8045ZM15.8792 13.5269C15.6539 15.8289 15.1208 17.861 14.3454 19.3577C17.3046 18.1721 19.4876 15.4606 19.9212 12.1964C18.861 12.7479 17.4647 13.209 15.8792 13.5269ZM19.9285 9.86013C19.458 10.3883 17.9737 11.0157 15.9962 11.4541C15.9987 11.3035 16 11.1521 16 11C16 7.67236 15.3944 4.6673 14.3454 2.64231C17.3216 3.83471 19.5128 6.57077 19.9285 9.86013Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.02dc483a.svg";
export { ForwardRef as ReactComponent };